<template>

  <main>

    <section class="container pt-3 pb-5">
      <div class="col-12 col-md-6 offset-md-3">
        <div class="d-flex justify-content-center align-items-center mb-3">
            <!-- <div>Kép</div>-->
          <picture v-if="imgPath">
  <!--      <source srcset="sample-image-desktop.jpg" media="(min-width: 768px)" type="image/svg+xml">-->
  <!--      <img src="sample-image-mobile.jpg" class="img-fluid img-thumbnail" alt="...">-->
            <img :src="imgPath" class="photo">
          </picture>
        </div>

        <div class="text-primary">{{program.date}} {{program.startTime}}-{{program.endTime}} / {{program.locationName}}</div>
        <h1 class="h5" v-html="program.name"></h1>
        <div v-html="program.description"></div>

        <div v-if="program.hasOwnProperty('children') && program.children!==null && program.children[0].hasOwnProperty('dates') && pageDisplay.bookingStartDate < serverDateTime">
          <hr>
          <div class="fw-bold mb-3 text-secondary">Előzetes időpontfoglalás szükséges az alábbi programoknál</div>
          <div class="d-flex flex-wrap align-items-center mb-2" v-for="(children,index) in program.children" :key="children.idNr">
            <div class="me-2 mb-2 fw-bold w-100" v-html="children.name"></div>
            <template v-if="haveParticipated(children.idNr)===false">
              <select class="form-select form-select-sm me-2 mb-2"  style="max-width: 170px;" v-model="selectedDate[index]">
                <option value="0">Válassz időpontot</option>
                <option v-for="date in children.dates" :value="date.id" :disabled="date.participated===true">{{date.startDateTime}} - {{date.endDateTime}} <span class="text-small" v-if="date.participated===true">foglalt</span></option>
              </select>
              <button class="btn btn-outline-primary btn-sm mb-2" @click="selectDate(children.idNr,index)">
                Időpont lefoglalása
              </button>
            </template>
            <template v-else>
              <div class="mb-2">
                - már van foglalásod, megtekintheted a <router-link :to="{name:'userAccount'}">Profilodban</router-link>.
              </div>
            </template>
          </div>
        </div>
<!--        <div v-if="program.preRegistration==='0'">-->
<!--          <div class="btn btn-warning form-control mt-3">-->
<!--            A program nincs előzetes jelentkezéshez kötve-->
<!--          </div>-->
<!--        </div>-->
        <button class="btn btn-secondary form-control mt-3 mb-2" v-if="program.preRegistration==='1' && serverDateTime<program.regStartTime">
          Jelentkezés indul: {{program.regStartTimeDisplay}}
        </button>
        <router-link v-if="program.preRegistration==='1' && serverDateTime>program.regStartTime && serverDateTime<program.regEndTime" :to="{name:'userParticipation', hash: program.teamEntry=='1' ? '#programs' : '#personal-entry'}">
          <button class="btn btn-primary form-control mt-3 mb-2">Jelentkezés / Nevezés</button>
        </router-link>
        <button class="btn btn-secondary form-control mt-3" v-if="program.preRegistration==='1' && serverDateTime>program.regEndTime">
          Jelentkezést lezártuk
        </button>
        <div v-if="program.preRegistration==='1' && serverDateTime<program.regEndTime" class="text-center">
          Jelentkezést zárjuk: {{program.regEndTimeDisplay}}
        </div>
        <div class="d-flex">
          <router-link :to="{name:'agenda'}" class="d-block w-100">
            <button class="btn btn-outline-primary form-control mt-5"><i class="bi bi-arrow-left me-2"></i>Vissza</button>
          </router-link>
          <a v-if="program.mapUrl && serverDateTime>mapDisplay" :href="program.mapUrl" target="_blank" class="d-block w-100 ms-2">
            <button class="btn btn-outline-primary form-control mt-3"><i class="bi bi-pin-map me-2"></i>Térkép</button>
          </a>
        </div>
      </div>
    </section>

  </main>

</template>


<script>
  import {Response} from "@/classes/response";

  export default {
    name: 'ProgramDetails',
    props: ['initData','programId'],
    data(){
      let loggedIn = this.initData.user.loggedIn
      if(loggedIn===false){
        this.$router.push({name: 'login'})
      }
      let eventData = this.initData.event
      let mapSetup = eventData.mapSetup
      let mapDisplay = eventData.pageDisplay.map
      let serverDateTime = this.initData.user.serverDateTime
      let generalContents = this.initData.lang.general
      let pageDisplay = eventData.pageDisplay

      let programsData = this.initData.programs.data

      let program = programsData.find(p => p.idNr === this.programId);
      if(program===undefined){
        this.$router.push({name: 'agenda'})
      }

      let eventId = this.initData.event.id

      let prefix = '/app'
      if(window.location.hostname=== 'localhost'){
        prefix = ''
      }
      // Cache-busting: a program-képek fix néven vannak (nincs hash a fájlnévben).
      // A verzió build-időben áll be (vue.config.js → VUE_APP_BUILD_VERSION),
      // így minden deploy után frissül a böngésző-cache. Fallback dev-hez.
      let imgVersion = process.env.VUE_APP_BUILD_VERSION || 'dev'
      let imgPath = prefix+'/img/events/'+eventId+'/programs/'+program.idNr+'.jpg?v='+imgVersion

      let http = new XMLHttpRequest()
      http.open('HEAD', imgPath, false)
      http.send()
      if(http.status===404){
        imgPath = false
      }

      return {
        mapSetup,
        mapDisplay,
        pageDisplay,
        serverDateTime,
        generalContents,
        program,
        imgPath,
        selectedDate: {
          0: '0',
          1: '0',
          2: '0',
          3: '0',
          4: '0',
          5: '0',
        }
      }
    },
    computed:{
      programDates(){
        return this.initData.user.programDates
      }
    },
    methods:{
      selectDate(idNr, index) {
        let formData = new FormData()
        formData.append('idNr', idNr)
        formData.append('dateId', this.selectedDate[index])

        this.initData.loader = true
        this.$axios.post('/v1/user/programDateParticipate',formData)
          .then((response) => {
            let responseData =  new Response().handle(response)
            this.initData.alerts.push({msg: responseData.msg, type: responseData.msgType})

            if(responseData.status===true) {
              this.initData.user.programDates = responseData.data.programDates
            }
          })
          .catch(error => {
            console.log(error)
            let responseData =  new Response()
            responseData.errorHandle(error.response)
            this.initData.alerts.push({msg: responseData.msg, type: responseData.msgType})
          })
          .then(() => {
            this.initData.loader = false
          });
      },
      haveParticipated(idNr){
        let programDates = this.initData.user.programDates
        return programDates.some(date => parseInt(date.idNr) === parseInt(idNr));
      }
    }
  }
</script>


<style scoped>

</style>